import { render, staticRenderFns } from "./SFPreloader.vue?vue&type=template&id=dfc59c30&lang=pug&"
import script from "./SFPreloader.vue?vue&type=script&lang=ts&"
export * from "./SFPreloader.vue?vue&type=script&lang=ts&"
import style0 from "./SFPreloader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports